import { d as dist } from './index-bd7e9b86.js';
import './core.esm-901288dd.js';
import './_commonjsHelpers-357b3b4e.js';
import './inheritsLoose-6f2ea841.js';
import 'react';
import 'react-dom';
import './assertThisInitialized-db62c3c4.js';
import './objectWithoutPropertiesLoose-6737dabb.js';
import './index-5fd269e1.js';
import './index-48edd52c.js';
import './index-a67b9a05.js';

const useNotification = () => {
  const {
    addToast
  } = dist.useToasts();
  return ({
    descriptionText,
    testID,
    titleText,
    variant
  }) => {
    addToast({
      descriptionText,
      testID,
      titleText
    }, {
      appearance: variant
    });
  };
};

export { useNotification as default };
//# sourceMappingURL=useNotification.js.map
